<template>
  <div>
    <div class="card-body print-form" id="receiptData">
      <b-row class="">
        <b-col cols="12">
          <table style="width: 400px; margin: 0px 5px">
            <div class="row">
              <tr>
                <td style="color: black; text-align: center">
                  {{ DateTime | formatDateTime }}
                </td>
              </tr>
            </div>
          </table>
          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span>
                  <h1
                    class="mb-0 tx-rubik text-center company_name text-uppercase shop-header"
                  >
                    Daily Summary Details
                  </h1>
                </span>
              </td>
            </tr>
          </table>

          <hr class="hor_line" />
        </b-col>
      </b-row>
      <b-row> </b-row>
      <hr style="b margin-bottom: 10px" />
      <b-row>
        <b-col>
          <table style="width: 400px; margin: 0px 5px">
            <thead>
              <tr style="border-bottom: solid 2px">
                <th class="description" style="color: black; text-align: left">
                  Item
                </th>
                <th class="empty"></th>
                <th class="description" style="color: black; text-align: left;">
                  Cost
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="text-decoration: underline">
                  Orders
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Total Amount
                  </h4>
                </td>
                <td></td>
                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.order.totalAmount
                        ? Data.order.totalAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Paid Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.order.paidAmount
                        ? Data.order.paidAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Cash Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.order.cashAmount
                        ? Data.order.cashAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Card Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.order.CardAmount
                        ? Data.order.CardAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Pending Card Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.order.PendingCardAmount
                        ? Data.order.PendingCardAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Pending Cash Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.order.PendingCashAmount
                        ? Data.order.PendingCashAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>

               <tr>
                <td style="text-decoration: underline">
                  Reservations
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Total Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.reservation.totalAmount
                        ? Data.reservation.totalAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Paid Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.reservation.paidAmount
                        ? Data.reservation.paidAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
               <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Order Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.reservation.orderAmount
                        ? Data.reservation.orderAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
               <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Room Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.reservation.roomAmount
                        ? Data.reservation.roomAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Cash Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.reservation.cashAmount
                        ? Data.reservation.cashAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Card Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.reservation.CardAmount
                        ? Data.reservation.CardAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Pending Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                       (Data.reservation.totalAmount-Data.reservation.paidAmount)| formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Pending Card Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.reservation.PendingCardAmount
                        ? Data.reservation.PendingCardAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Pending Cash Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.reservation.PendingCashAmount
                        ? Data.reservation.PendingCashAmount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
               <tr>
                <td style="text-decoration: underline">
                  Totals
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Total Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.total_amount
                        ? Data.total_amount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-top: dashed 1px">
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 170px;
                  "
                >
                  <h4 class="text-left padding-top-0px">
                    Settled Amount
                  </h4>
                </td>
                <td></td>

                <td class="text-center padding-top-0px letter2">
                  <span>
                    {{
                      Data.settled_amount
                        ? Data.settled_amount
                        : "0.00" | formatCurrency
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <hr style="border-top: solid 1px; margin: 3px" />
          <table style="width: 400px; margin: 40px 5px">
            <tr style="margin: 30px 0px">
              <td
                colspan="2"
                class="description"
                style="color: black; text-align: left"
              >
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold; top:20px"
                >
                  <span>-----------------------</span><br />
                  Signature
                </span>
              </td>
            </tr>

            <tr style="margin-top: 30px">
              <td
                colspan="2"
                style="
                  font-size: 12px;
                  padding-top: 20px;
                  color: black;
                  text-align: center;
                "
              >
                Powered by SpeedCodeLabs (Pvt) Ltd | 0212 211 599
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrintBill",
  data() {
    return {
      printing: false
    };
  },
  props: {
    Data: {
      type: Object,
      default: {}
    },
    DateTime: {
      type: Object,
      default: {}
    }
  },
  components: {},
  computed: {},
  methods: {
    print() {
      this.$htmlToPaper("receiptData");
    }
  }
};
</script>
<style>
.numformat {
  font-size: 115px;

  margin-left: 17px;
  top: -54px;
}
.textAllignments {
  text-align: start;
  width: 80px;
}
.description,
.description {
  width: 100px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.empty{
  width: 5px;
}
.letter2 {
  font-size: 20px;
}

.unit-price,
.unit-price {
  width: 90px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.unit-price-text {
  text-align: right;
}

.quantity,
.quantity {
  width: 40px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.discount,
.discount {
  width: 90px;
  word-break: break-all;
  padding: 0px 10px;
}

.amount,
.amount {
  width: 100px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.centered {
  text-align: center;
  align-content: center;
}

.ticket {
  width: 155px;
  max-width: 155px;
}

img {
  max-width: inherit;
  width: inherit;
}
#receiptData {
  width: 100%;
  background: white;
}
</style>
